export function reduceTotalValues(response) {


  //If no initialValue was provided, then previousValue will be equal to 
  //the first value in the array and currentValue will be equal to the second.
  //PlannedKM

  const planKM = response.reduce(
    (accumulator, currentValue) => accumulator + currentValue.planneddist, 0
  )

  //RealKM
  const realKM = response.reduce(
    (accumulator, currentValue) => accumulator + parseFloat(currentValue.realdist), 0
  )

  //PlannedDuration
  const planDuration = response.reduce(
    (accumulator, currentValue) => accumulator + currentValue.plannedduration, 0
  )

  //RealDuration
  const realDuration = response.reduce(
    (accumulator, currentValue) => accumulator + parseFloat(currentValue.realduration), 0
  )

  //PlannedTrips
  const planTrips = response.reduce(
    (accumulator, currentValue) => accumulator + currentValue.plantripcount, 0
  )

  //RealTrips
  const realTrips = response.reduce(
    (accumulator, currentValue) => accumulator + currentValue.realtripcount, 0
  )

  //Trip pct avg
  const tripsAvg = response.reduce(
    (accumulator, currentValue) => accumulator + currentValue.tripspct,0
  ) / response.length*100;

  //Duration pct avg
  const durationAvg = response.reduce(
    (accumulator, currentValue) => accumulator + currentValue.durationpct,0
  ) / response.length*100;

  //Km pct avg
  const kmAvg = response.reduce(
    (accumulator, currentValue) => accumulator + currentValue.kmpct,0
  ) / response.length *100;

  return [
    {
      planDuration,
      realDuration,
      planKM,
      realKM,
      planTrips,
      realTrips,
      tripsAvg,
      durationAvg,
      kmAvg
    }
  ]


}